module.exports = __webpack_public_path__ + "static/app_gyver-d2a1f27264fd3a004fe79f3ee8b0fab3.svg";